<template>
    <div class="tab-panel padded">
        <agent @updateFields="updateFields"></agent>

        <basic></basic>

        <price-counters @updatePrices="updatePrices" :editable="false"></price-counters>

        <customer @updateFields="updateFields"></customer>

        <transport @updateFields="updateFields"></transport>

        <extras @updateExtras="updateExtras" :editable="false"></extras>

        <notes @updateNotes="updateNotes"></notes>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import Agent from '../Agent'
    import Basic from '../BasicData'
    import PriceCounters from '../PriceCounters'
    import Customer from '../Customer'
    import Transport from '../Transport'
    import Extras from '../Extras'
    import Notes from '../Notes'

    export default {
        data: function() {
            return {
                form: {},
            }
        },
        created: function() {
            this.form = this.getClonedReservation;
        },
        computed: {
            ...mapGetters([
                'getClonedReservation',
            ]),
        },
        methods: {
            ...mapActions([
                'updateClonedReservation',
            ]),
            updateFields: function(fields) {
                if (fields) {
                    Object.keys(fields).forEach((key) => {
                        this.$set(this.form, key, fields[key]);
                    });

                    this.updateClonedReservation(this.form);
                }
            },
            updatePrices: function(prices) {
                this.form.event.product.prices = prices;

                this.updateClonedReservation(this.form);

                console.log('Updated clonedReservation after updatePrices trigger for prices', prices, ' with ', this.getClonedReservation);
            },
            updateExtras: function(extras) {
                this.form.event.product.extras = extras;

                this.updateClonedReservation(this.form);

                console.log('Updated clonedReservation after updateExtras trigger for extras', extras, ' with ', this.getClonedReservation);
            },
            updateNotes: function(notes) {
                this.form.notes = notes;

                this.updateClonedReservation(this.form);

                console.log('Updated clonedReservation after updateNotes trigger for notes', notes, ' with ', this.getClonedReservation);
            },
        },
        components: {
            Agent,
            Basic,
            PriceCounters,
            Customer,
            Transport,
            Extras,
            Notes,
        },
    }
</script>

<style lang="scss" scoped>
    .tab-panel .basic-data {
        > .event {
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
        }
    }
</style>



// WEBPACK FOOTER //
// ViewMore.vue?916b2c80